export default __webpack_public_path__ + "assets/cooper.5bdcd1b7.png";